@if (auftrag(); as auftrag) {
  <div
    class="soft-card rounded-m flex flex-row flex-nowrap center-v overflow-hidden relative cursor-pointer transition-colors hover:bg-hover"
    (click)="openAuftrag(auftrag)"
  >
    <div class="absolute top-0 bottom-0 left-0 w-1.5 rounded-l-m bg-primary"></div>
    <div class="flex flex-row justify-between flex-nowrap center-v flex-1 p-2">
      <div class="flex flex-col justify-center flex-nowrap flex-1 mr-1">
        <span class="font-bold mt-1 mb-1">
          {{ '#TRANSPORT.LIST.ITEM.NAME_PREFIX' | translate }} {{ auftrag.nummer }}
        </span>
        <span class="text-sm mb-1">{{ auftrag.stationen }}</span>
        <div
          class="flex flex-row items-center justify-between flex-nowrap w-full mt-1 mb-1"
        >
          <div class="flex flex-row items-center">
            <i class="fa-regular fa-truck mr-2 text-sm"></i>
            <span class="text-sm">
              {{ auftrag.lkw?.bezeichnung }} {{ auftrag.lkw?.kennzeichen }}
            </span>
          </div>
          <span class="text-sm color-light">
            {{ auftrag.lieferdatum | date: 'dd.MM.yyyy' }}
          </span>
        </div>
      </div>
      <div class="flex items-center">
        <i class="fa-regular fa-chevron-right text-sm color-lighter ml-2"></i>
      </div>
    </div>
  </div>
}
